import ISystemSettings from "interfaces/ISystemSettings";
import { GlobalState } from "little-state-machine";

export const updateSystemSettings = (
  state: GlobalState,
  systemSettings: ISystemSettings
) => ({
  ...state,
  systemSettings
});
